import { render, staticRenderFns } from "./ExistingEditor.vue?vue&type=template&id=4e905e5e&scoped=true&"
import script from "./ExistingEditor.vue?vue&type=script&lang=js&"
export * from "./ExistingEditor.vue?vue&type=script&lang=js&"
import style0 from "./ExistingEditor.vue?vue&type=style&index=0&id=4e905e5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e905e5e",
  null
  
)

export default component.exports